export const enum QUERY_KEYS {
    WEBINARS_LIST = 'webinars_list',
    WEBINAR = 'webinar',
}
